const ja_JP = {
  "colorpicker.opacity-input": "不透明度",
  "datepicker.clear-date": "日付を消去する",
  "datepicker.next-month": "来月",
  "datepicker.open-calendar": "カレンダーを開く",
  "datepicker.previous-month": "前月",
  "input.clear": "入力をクリア",
  "input.hide-password": "パスワードを隠す",
  "input.show-password": "パスワードを表示",
  "modal.close": "閉じる",
  "multiselectchips.add-value": "「 {value} 」を追加",
  "multiselectchips.remove-all": "すべてを削除する",
  "pagination.next-page": "次のページ",
  "pagination.previous-page": "前のページ"
};
export {
  ja_JP as default
};
//# sourceMappingURL=ja_JP.json.js.map
